import * as d3 from 'd3';

import { TsPoint } from './MultiLineChart.types';

export const drawThresholdFill = (
  ctx: CanvasRenderingContext2D,
  thresholdData: TsPoint[],
  xScale: d3.ScaleLinear<number, number> | d3.ScaleTime<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  width: number,
  height: number,
  threshold: number,
  fillColors: {
    positive: string;
    negative: string;
    neutral?: string;
  },
  dateToIndexMap?: Map<number, number>,
  tooltipXPos?: number
) => {
  const yThreshold = yScale(threshold);
  ctx.clearRect(0, 0, width, height);

  const areaPath = d3
    .area<TsPoint>()
    .x(d => {
      if (!dateToIndexMap) {
        return xScale(d.date.getTime());
      }

      const index = dateToIndexMap.get(d.date.getTime());
      return index !== undefined ? xScale(index) : 0;
    })
    .y0(yThreshold)
    .y1(d => yScale(d.value))
    .curve(d3.curveLinear)(thresholdData);

  if (!areaPath) {
    return;
  }

  ctx.save();
  ctx.globalCompositeOperation = 'destination-over';

  const path = new Path2D(areaPath);
  ctx.clip(path);

  if (tooltipXPos !== undefined && fillColors.neutral) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, tooltipXPos, height);
    ctx.clip();
    ctx.fillStyle = fillColors.positive;
    ctx.fillRect(0, 0, tooltipXPos, yThreshold);
    ctx.fillStyle = fillColors.negative;
    ctx.fillRect(0, yThreshold, tooltipXPos, height - yThreshold);
    ctx.restore();

    ctx.save();
    ctx.globalAlpha = 0.15;
    ctx.beginPath();
    ctx.rect(tooltipXPos, 0, width - tooltipXPos, height);
    ctx.clip();
    ctx.fillStyle = fillColors.neutral;
    ctx.fillRect(tooltipXPos, 0, width - tooltipXPos, height);
    ctx.restore();
  } else {
    ctx.fillStyle = fillColors.positive;
    ctx.fillRect(0, 0, width, yThreshold);
    ctx.fillStyle = fillColors.negative;
    ctx.fillRect(0, yThreshold, width, height - yThreshold);
  }

  ctx.restore();
};
